import { faCancel, faCheck, faClose, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { notify } from 'utils/marketplace';
import { IRefOrder } from 'applications/automotor/views/espace-automotor-order/automotor-order.mode';
import { IImportFileNew } from 'interfaces/price';
import ReferenceSearchOrder from '../../ReferenceSearchOrder/ReferenceSearchOrder';


type Props = {

  index: number;
  item
  setData: (data: IRefOrder[]) => void;
  rowsData: IRefOrder[];
  setValidatePressedRows: (rows: string[]) => void;
  validatePressedRows: string[];
  setStepModal: (step: string) => void;
  currentPage
  setCurrentPage: (page: number) => void;
  itemsPerPage: number;
};


const ActionContentElement: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [confirmChangeRef, setConfirmChangeRef] = useState(false);
  const [selectedItem, setSelectedItem] = useState<IImportFileNew>();
  const [resetInputRef, setResetInputRef] = useState(false);

  const handleOkClick = (index) => {


    if (props.validatePressedRows.includes(index)) {
      // Șterge index-ul
      props.setValidatePressedRows(
        props.validatePressedRows.filter((i) => i !== index)
      );
    } else {
      // Adaugă index-ul
      props.setValidatePressedRows([...props.validatePressedRows, index]);
    }
  };

  // Function to remove an item from the data table
  // and update the local storage
  const removeItem = (item) => {


    const dataTable = props.rowsData.filter((row) => !(row.reference == item.reference && row.index == item.index));
    const updatedRows = proformaFile.rows.filter((row) => !(row.data[4] == String(item.reference) && row.data[0] == item.index));

    localStorage.setItem('proformaFileInProgress', JSON.stringify({ ...proformaFile, count: proformaFile.count - 1, rows: updatedRows }));
    notify(t('_references_deleted'), 'success', t('_success'));
    props.setData(dataTable);

    if (props.currentPage === 1) {
      props.setCurrentPage(props.currentPage);
    }
    else if (props.currentPage > Math.ceil(dataTable.length / props.itemsPerPage)) {
      props.setCurrentPage(Math.ceil(dataTable.length / props.itemsPerPage));
    } else {
      props.setCurrentPage(props.currentPage);
    }

    if (dataTable.length === 0) {
      props.setStepModal('ValidationReferencesPriceNotOK');
    }

  };
  // finish remove item


  const show = (id: string, type, event: React.MouseEvent) => {
    event.stopPropagation();
    document.getElementById(String(id))!.style.display = type;
  };

  const onclickConfirmRef = (status: boolean) => {
    if (status) {
      if (selectedItem) {

        const isRefExists = proformaFile.partsWithReplacements.some((item) =>
          item.parts.some((part) => part.reference == selectedItem.parts[0].reference)
        );


        if (isRefExists) {
          notify(t('_item_already_exists'), 'warning');
          // setConfirmChangeRef(false); 

          // return;
        }


        const updatedRows = proformaFile.rows.map((row => {
          if (row.data[4] === String(props.item.reference) && row.data[0] === props.index) {
            selectedItem.parts[0].quantity = row.data[6];
            selectedItem.parts[0].total = row.data[6] * Number(selectedItem.parts[0].price);
            selectedItem.parts[0].old_reference = row.data[4];
            row.replaceRef = status;
            row.newRef = selectedItem;
          }

          return row;
        }));

        localStorage.setItem('proformaFileInProgress', JSON.stringify({ ...proformaFile, rows: updatedRows }));

        const dataTable = props.rowsData.map((row) => {
          if (row.reference === props.item.reference && row.index === props.index) {
            row.replaceRef = status;
            row.newRef = selectedItem;
          }

          return row;
        });

        handleOkClick(props.item.reference + props.index);
        props.setData(dataTable);

        setConfirmChangeRef(true);

        notify(t('_reference_added_successfully'), 'success', t('_success'));


      } else {
        notify(t('_select_reference'), 'error', t('_error'));
        setConfirmChangeRef(false);
      }


    } else {
      const updatedRows = proformaFile.rows.map((row => {
        if (row.data[4] === String(props.item.reference) && row.data[0] === props.index) {
          row.replaceRef = status;
          row.newRef = undefined;
        }

        return row;
      }));

      localStorage.setItem('proformaFileInProgress', JSON.stringify({ ...proformaFile, rows: updatedRows }));

      const dataTable = props.rowsData.map((row) => {
        if (row.reference === props.item.reference && row.index === props.index) {
          row.replaceRef = status;
          row.newRef = undefined;
        }

        return row;
      });


      props.setData(dataTable);
      setConfirmChangeRef(false);
      notify(t('_references_not_valid'), 'success', t('_success'));
      setSelectedItem(undefined);
      setResetInputRef(true);
      handleOkClick(props.item.reference + props.index);
    }


  };

  return (
    <React.Fragment key={props.index}>
      <ReferenceSearchOrder currentPage={props.currentPage} item={props.item} index={props.item.reference + props.index} setSelectedItem={setSelectedItem} resetInputRef={resetInputRef} setResetInputRef={setResetInputRef} />
      {confirmChangeRef || props.item.replaceRef
        ? <div className="no-validate" onClick={() => { onclickConfirmRef(false); }} > <FontAwesomeIcon icon={faCancel} />   {t('_cancel')} </div>
        : <div className="validate" onClick={() => onclickConfirmRef(true)} > <FontAwesomeIcon icon={faCheck} />   {t('_validate')} </div>
      }

      <div className="remove" onClick={(event) => show('delete' + props.item.reference + props.index, 'block', event)} ><FontAwesomeIcon icon={faTrashCan} />
        <div className="tooltip-order"
          id={String('delete' + props.item.reference + props.index)}
          onMouseLeave={(event) =>
            setTimeout(() => {
              show(String('delete' + props.item.reference + props.index), 'none', event);
            }, 100)
          }
        >
          <div className="tooltip_lable">
            <button className="yes" onClick={() => removeItem(props.item)}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
            <button className="no" onClick={(event) => show('delete' + props.item.reference, 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
          </div>
        </div>
      </div>

    </React.Fragment >
  );
};

ActionContentElement.displayName = 'ActionContentElement';

export default ActionContentElement;
